import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
  SupplierPayment, SupplierPaymentCreateDTO, SupplierPaymentResponse,
  PaymentEditDTO, SupplierPaymentEdit,
} from '../interfaces/procurement/supplierPayment.interface';

export const SupplierPaymentService = {
  listByBill: async (supplierBillId: string, page = 0, size = 10): Promise<SupplierPaymentResponse> =>
    (await axios.get(`${ENDPOINTS.SUPPLIER_PAYMENT.LIST_BY_BILL(supplierBillId)}?page=${page}&size=${size}`)).data,
  getById: async (id: string): Promise<SupplierPayment> =>
    (await axios.get(ENDPOINTS.SUPPLIER_PAYMENT.GET_BY_ID(id))).data,
  create: async (dto: SupplierPaymentCreateDTO): Promise<SupplierPayment> =>
    (await axios.post(ENDPOINTS.SUPPLIER_PAYMENT.CREATE, dto)).data,
  reverse: async (id: string): Promise<SupplierPayment> =>
    (await axios.post(ENDPOINTS.SUPPLIER_PAYMENT.REVERSE(id))).data,
  edit: async (id: string, dto: PaymentEditDTO): Promise<SupplierPayment> =>
    (await axios.put(ENDPOINTS.SUPPLIER_PAYMENT.EDIT(id), dto)).data,
  editHistory: async (id: string): Promise<SupplierPaymentEdit[]> =>
    (await axios.get(ENDPOINTS.SUPPLIER_PAYMENT.EDIT_HISTORY(id))).data,
};
